'use client'

import React from 'react'

import { Box, HTMLChakraProps } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  activeIncidentCardBodyStyles,
  activeIncidentCardContentStyles,
  activeIncidentCardIconStyles,
  activeIncidentCardStyles,
  activeIncidentCardTitleStyles,
} from './ActiveIncidentCard.styles'

export type ActiveIncidentCardProps = HTMLChakraProps<'div'> & {
  colorScheme?: ColorScheme
  /** Incident-type icon rendered in the 24px leading column. */
  icon?: React.ReactNode
  /** Single-line heading (e.g. "INC-123 Door forced open"); truncates. */
  title: string
  /** Secondary line — timestamp / source / facility. */
  subtitle?: React.ReactNode
  /** Renders a hairline divider beneath the row. Defaults to true. */
  showDivider?: boolean
}

/**
 * Compact active-incident list row: a leading incident-type icon, a
 * single-line link-coloured title and a secondary subtitle line, with an
 * optional divider. A plain div, so consumers add their own
 * cursor/role/tabIndex/onKeyDown for interactivity.
 */
export const ActiveIncidentCard = ({
  colorScheme = 'dark',
  icon,
  title,
  subtitle,
  showDivider = true,
  ...rest
}: ActiveIncidentCardProps) => (
  <Box {...activeIncidentCardStyles(colorScheme, showDivider)} {...rest}>
    <Box {...activeIncidentCardBodyStyles}>
      {icon && <Box {...activeIncidentCardIconStyles}>{icon}</Box>}
      <Box {...activeIncidentCardContentStyles}>
        <Box as='p' {...activeIncidentCardTitleStyles(colorScheme)}>
          {title}
        </Box>
        {subtitle}
      </Box>
    </Box>
  </Box>
)
